import { clsx } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
    return twMerge(clsx(inputs))
}

export function createPageUrl(page) {
    if (!page) return "/";
    // Convert PascalCase/camelCase to kebab-case
    return "/" + page.replace(/([a-z0-9])([A-Z])/g, '$1-$2').toLowerCase();
}
